<kt-portlet>
        <kt-portlet-header [class]="'kt-portlet__head--lg'">
            <ng-container ktPortletTitle>
                <div *ngIf="pageLoading$ | async">
                    <ngx-skeleton-loader count="1" appearance="line" [theme]="{'margin-bottom': '-4px','width':'100%'}"></ngx-skeleton-loader>
                </div>
                <div class="thirdparty-score" *ngIf="!(pageLoading$ | async)">
                    {{'SCORE_PAGE.HEADER.TITLE' | translate | stringFormat: thirdPartyName}}
                    &nbsp;
                    <i class="flaticon2-hexagonal" [style.color]="'#' + (evaluationResult$ | async).level.color"></i>
                    {{ (evaluationResult$ | async).level.description }}
                </div>
            </ng-container>

            <ng-container ktPortletTools>
                <button
                    mat-raised-button color="primary"
                    [disabled] = "!(editLocked$ | async)"
                    (click) = "openLockDialog()"
                    [matTooltip]="(editLocked$ | async)?
                                    ('SCORE_PAGE.HEADER.TOOLTIP.LOCK_BUTTON_LOCKED' | translate) :
                                    ('SCORE_PAGE.HEADER.TOOLTIP.LOCK_BUTTON_UNLOCKED' | translate)">
                    <i *ngIf="(editLocked$ | async)" class="material-icons md-24">lock</i>
                    <i *ngIf="!(editLocked$ | async)" class="material-icons md-24">lock_open</i>
                    {{'SCORE_PAGE.HEADER.LOCK_BUTTON' | translate}}
                </button>
            </ng-container>
        </kt-portlet-header>

        <kt-portlet-body>
            <!-- LOADER -->
            <div *ngIf="pageLoading$ | async" style="align-self: center; width: fit-content;">
                <mat-progress-spinner [diameter]="40" color="primary" mode="indeterminate"></mat-progress-spinner>
            </div>
            <!-- LOADER -->
            <!-- MAIN PAGE -->
            <div *ngIf="!(pageLoading$ | async)">
                <div class="evaluation-result-message">
<!--                {{ -->
<!--                    'SCORE_PAGE.RESULT.LABEL' | translate | stringFormat: -->
<!--                    ('DATA.THIRDPARTY_EVALUATION.STAGE.' +  (evaluationResult$ | async).stageName.toUpperCase() | translate) : -->
<!--                    ((evaluationResult$ | async).score | number: '1.2-2') -->
<!--                }}       -->
                {{
                    'SCORE_PAGE.RESULT.LABEL' | translate | stringFormat:
                    (evaluationResult$ | async).nextStageAppFormDescription :
                    ((evaluationResult$ | async).score | number: '1.2-2')
                }}
                </div>

                <div class="row">
                    <div class="col-lg-12">
                        <mat-radio-group
                            class="radio-group-control"
                            [(ngModel)]="nextAction"
                            [disabled]="editLocked$ | async">
                                <mat-radio-button
                                    *ngIf="!(evaluationResult$ | async).isFinalStage"
                                    [value]="nextEvaluationAction.NextWorkFlowStep">
                                    {{ 'SCORE_PAGE.RESULT.NEXT_STAGE' | translate }}
                                </mat-radio-button>
                                <mat-radio-button
                                    *ngIf="!(evaluationResult$ | async).isFinalStage &&
                                            (evaluationResult$ | async).isNextAppFormAvailable"
                                    [value]="nextEvaluationAction.SkipNextWorkFlowStageAndRegenarate">
                                    {{ 'SCORE_PAGE.RESULT.SKIP_NEXT_STAGE_AND_REGENERATE' | translate }}
                                </mat-radio-button>
                                <mat-radio-button
                                    *ngIf="!(evaluationResult$ | async).isBeforeFinalStage && !(evaluationResult$ | async).isFinalStage"
                                    [value]="nextEvaluationAction.ByPassNextWorkFlowStage">
                                    {{ 'SCORE_PAGE.RESULT.BYPASS_NEXT_STAGE' | translate }}
                                </mat-radio-button>
                                <mat-radio-button
                                    *ngIf="(evaluationResult$ | async).isFinalStage"
                                    [value]="nextEvaluationAction.Reject">
                                    {{ 'SCORE_PAGE.RESULT.REJECT' | translate }}
                                </mat-radio-button>
                                <mat-radio-button [value]="nextEvaluationAction.ApproveWithTracing">
                                    {{ 'SCORE_PAGE.RESULT.FINALIZE_EVALUATION' | translate }}
                                </mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>

                <div style="position: relative; top: 2em;" *ngIf="nextAction === nextEvaluationAction.ApproveWithTracing">
                    <div class="action-label">{{'SCORE_PAGE.TABLE_DEFAULT_ACTIONS.TITLE' | translate}}</div>

                    <kt-portlet class="kt-portlet--bordered" style="margin-top: 3em">
                        <kt-portlet-body>
                            <div class="lmat-elevation-z8">
                                <div class="mobile-table-container">
                                    <!-- Tabla lista de terceros -->
                                <mat-table #tracingActionTable [dataSource]="recommendedActionsDataSource" class="mobile-table">
                                    <ng-container matColumnDef="reviewed" >
                                        <mat-header-cell *matHeaderCellDef class="recommended-col">
                                            <div>
                                                <!-- <mat-checkbox #globalSelectionReview
                                                    matTooltip="Revisión"
                                                    [disabled]="editLocked$ | async"
                                                    (change)="$event ? toogleAllReviewedSelection(globalSelectionReview.indeterminate) : null"
                                                    [checked]="getDeterminateReviewedSelectionState()"
                                                    [indeterminate]="isIndeterminateReviewedSelection()">
                                                </mat-checkbox> -->
                                                {{'SCORE_PAGE.TABLE_DEFAULT_ACTIONS.HEADER.REVIEW' | translate}}
                                            </div>
                                        </mat-header-cell>
                                        <mat-cell *matCellDef="let element" class="recommended-col">
                                            <div>
                                                <mat-checkbox
                                                    [(ngModel)]="element.activeReviewed"
                                                    [disabled]="(editLocked$ | async) || nextAction != nextEvaluationAction.ApproveWithTracing">
                                                </mat-checkbox>
                                            </div>
                                        </mat-cell>
                                    </ng-container>

                                    <ng-container matColumnDef="recommended" >
                                        <mat-header-cell *matHeaderCellDef class="recommended-col">
                                            <!-- <div>
                                                <mat-checkbox #globalSelection
                                                    [matTooltip]="!review? 'Propuesto' : 'Propuesto sistema'"
                                                    [disabled]="(editLocked$ | async) || review"
                                                    (change)="$event ? toogleAllSelection(globalSelection.indeterminate) : null"
                                                    [checked]="getDeterminateSelectionState()"
                                                    [indeterminate]="isIndeterminateSelection()">
                                                </mat-checkbox>
                                            </div>                                         -->
                                            <div *ngIf="!review">{{'SCORE_PAGE.TABLE_DEFAULT_ACTIONS.HEADER.DEFAULT' | translate}}</div>
                                            <div *ngIf="review">{{'SCORE_PAGE.TABLE_DEFAULT_ACTIONS.HEADER.DEFAULT_REVIEW' | translate}}</div>
                                        </mat-header-cell>
                                        <mat-cell *matCellDef="let element" class="recommended-col">
                                            <div>
                                                <mat-checkbox
                                                    [(ngModel)]="element.active"
                                                    [disabled]="((editLocked$ | async) || nextAction != nextEvaluationAction.ApproveWithTracing) || review">
                                                </mat-checkbox>
                                            </div>
                                        </mat-cell>
                                    </ng-container>

                                    <ng-container matColumnDef="tracingaction">
                                        <mat-header-cell *matHeaderCellDef class="cell-90p-w">{{'SCORE_PAGE.TABLE_DEFAULT_ACTIONS.HEADER.ACTION' | translate}}</mat-header-cell>
                                        <mat-cell *matCellDef="let element" class="cell-90p-w">{{element.description}}</mat-cell>
                                    </ng-container>

                                    <ng-container matColumnDef="noRecord">
                                            <mat-footer-cell *matFooterCellDef>
                                                <div style="width: 100%;text-align: center;">{{'SCORE_PAGE.TABLE_DEFAULT_ACTIONS.EMPTY' | translate}}</div>
                                            </mat-footer-cell>
                                    </ng-container>

                                    <ng-container matColumnDef="responsableRole">
                                            <mat-header-cell *matHeaderCellDef>{{'SCORE_PAGE.TABLE_DEFAULT_ACTIONS.HEADER.RESPONSABLE_ROLE' | translate}}</mat-header-cell>
                                            <mat-cell *matCellDef="let element">{{ element.roleDescription }}</mat-cell>
                                    </ng-container>

                                    <ng-container matColumnDef="use_last_plan" >
                                        <mat-header-cell *matHeaderCellDef class="recommended-col">
                                            {{'SCORE_PAGE.TABLE_DEFAULT_ACTIONS.HEADER.USE_LAST_PLAN' | translate}}
                                        </mat-header-cell>
                                        <mat-cell *matCellDef="let element" class="recommended-col">
                                            <div *ngIf="element.canBeReUsed">
                                                <mat-checkbox
                                                    [(ngModel)]="element.reUseTask"
                                                    [disabled]="(editLocked$ | async) || (review ? !element.activeReviewed : !element.active)">
                                                </mat-checkbox>
                                            </div>
                                        </mat-cell>
                                    </ng-container>

                                    <ng-container matColumnDef="reset_expiration" >
                                        <mat-header-cell *matHeaderCellDef class="recommended-col">
                                            {{'SCORE_PAGE.TABLE_DEFAULT_ACTIONS.HEADER.RESET_EXPIRATION' | translate}}
                                        </mat-header-cell>
                                        <mat-cell *matCellDef="let element" class="recommended-col">
                                            <div *ngIf="element.reUseTask">
                                                <mat-checkbox
                                                    [(ngModel)]="element.rebuiltExpirationDate"
                                                    [disabled]="(editLocked$ | async) || (review ? !element.activeReviewed : !element.active)">
                                                </mat-checkbox>
                                            </div>
                                        </mat-cell>
                                    </ng-container>

                                    <ng-container matColumnDef="view_detail">
                                        <mat-header-cell *matHeaderCellDef class="recommended-col">
                                            {{'SCORE_PAGE.TABLE_COMMON.HEADER.VIEW_DETAIL' | translate}}
                                        </mat-header-cell>
                                        <mat-cell *matCellDef="let element" class="recommended-col">
                                            <button mat-icon-button (click)="openPrevTaskDetail(element)"
                                                    *ngIf="element.canBeReUsed" >
                                                <mat-icon>visibility</mat-icon>
                                            </button>
                                        </mat-cell>
                                    </ng-container>

                                    <mat-header-row *matHeaderRowDef="displayedColumnsRecommended"></mat-header-row>
                                    <mat-row class="mobile-table-row" *matRowDef="let row; columns: displayedColumnsRecommended;"></mat-row>

                                    <mat-footer-row
                                        *matFooterRowDef="['noRecord']"
                                        [hidden]="recommendedActionsDataSource.data.length > 0">
                                    </mat-footer-row>
                                </mat-table>
                                </div>
                            </div>
                        </kt-portlet-body>
                    </kt-portlet>
                </div>

                <div *ngIf="(specialActionsDataSource.data.length > 0) && (nextAction === nextEvaluationAction.ApproveWithTracing)"
                    style="position: relative; top: 3em; margin-bottom: 2.5em;">
                    <div class="action-label">{{'SCORE_PAGE.TABLE_SPECIAL_ACTIONS.TITLE' | translate}}</div>

                    <kt-portlet class="kt-portlet--bordered" style="margin-top: 3em">
                        <kt-portlet-body>
                            <div class="lmat-elevation-z8">
                                <div class="mobile-table-container">
                                    <!-- Tabla acciones por respuesta -->
                                <mat-table [dataSource]="specialActionsDataSource" class="mobile-table">
                                    <ng-container matColumnDef="reviewed" >
                                        <mat-header-cell *matHeaderCellDef class="recommended-col">
                                            <div>
                                                {{'SCORE_PAGE.TABLE_SPECIAL_ACTIONS.HEADER.REVIEW' | translate}}
                                            </div>
                                        </mat-header-cell>
                                        <mat-cell *matCellDef="let element" class="recommended-col">
                                            <div>
                                                <mat-checkbox
                                                    [(ngModel)]="element.activeReviewed"
                                                    [disabled]="(editLocked$ | async) || nextAction != nextEvaluationAction.ApproveWithTracing">
                                                </mat-checkbox>
                                            </div>
                                        </mat-cell>
                                    </ng-container>

                                    <ng-container matColumnDef="recommended" >
                                        <mat-header-cell *matHeaderCellDef class="recommended-col">
                                            <div *ngIf="!review">{{'SCORE_PAGE.TABLE_SPECIAL_ACTIONS.HEADER.DEFAULT' | translate}}</div>
                                            <div *ngIf="review">{{'SCORE_PAGE.TABLE_SPECIAL_ACTIONS.HEADER.DEFAULT_REVIEW' | translate}}</div>
                                        </mat-header-cell>
                                        <mat-cell *matCellDef="let element" class="recommended-col">
                                            <div>
                                                <mat-checkbox
                                                    [(ngModel)]="element.active"
                                                    [disabled]="((editLocked$ | async) || nextAction != nextEvaluationAction.ApproveWithTracing) || review">
                                                </mat-checkbox>
                                            </div>
                                        </mat-cell>
                                    </ng-container>

                                    <ng-container matColumnDef="tracingaction">
                                        <mat-header-cell *matHeaderCellDef>{{'SCORE_PAGE.TABLE_SPECIAL_ACTIONS.HEADER.TASK' | translate}}</mat-header-cell>
                                        <mat-cell *matCellDef="let element">{{element.description}}</mat-cell>
                                    </ng-container>

                                    <ng-container matColumnDef="responsableRole">
                                            <mat-header-cell *matHeaderCellDef>{{'SCORE_PAGE.TABLE_SPECIAL_ACTIONS.HEADER.RESPONSABLE_ROLE' | translate}}</mat-header-cell>
                                            <mat-cell *matCellDef="let element">{{ element.roleDescription }}</mat-cell>
                                    </ng-container>

                                    <ng-container matColumnDef="use_last_plan" >
                                        <mat-header-cell *matHeaderCellDef class="recommended-col">
                                            {{'SCORE_PAGE.TABLE_DEFAULT_ACTIONS.HEADER.USE_LAST_PLAN' | translate}}
                                        </mat-header-cell>
                                        <mat-cell *matCellDef="let element" class="recommended-col">
                                            <div *ngIf="element.canBeReUsed">
                                                <mat-checkbox
                                                    [(ngModel)]="element.reUseTask"
                                                    [disabled]="(editLocked$ | async) || (review ? !element.activeReviewed : !element.active)">
                                                </mat-checkbox>
                                            </div>
                                        </mat-cell>
                                    </ng-container>

                                    <ng-container matColumnDef="reset_expiration" >
                                        <mat-header-cell *matHeaderCellDef class="recommended-col">
                                            {{'SCORE_PAGE.TABLE_DEFAULT_ACTIONS.HEADER.RESET_EXPIRATION' | translate}}
                                        </mat-header-cell>
                                        <mat-cell *matCellDef="let element" class="recommended-col">
                                            <div *ngIf="element.reUseTask">
                                                <mat-checkbox
                                                    [(ngModel)]="element.rebuiltExpirationDate"
                                                    [disabled]="(editLocked$ | async) || (review ? !element.activeReviewed : !element.active)">
                                                </mat-checkbox>
                                            </div>
                                        </mat-cell>
                                    </ng-container>

                                    <ng-container matColumnDef="actions">
                                        <mat-header-cell *matHeaderCellDef>{{'SCORE_PAGE.TABLE_EXTRA_ACTIONS.HEADER.ACTIONS' | translate}}</mat-header-cell>
                                        <mat-cell *matCellDef="let element">
                                            <button
                                            [matTooltip]="'SCORE_PAGE.TABLE_SPECIAL_ACTIONS.TOOLTIP.VIEW_DETAIL' | translate"
                                            mat-icon-button color="primary"
                                            class="medium"
                                            [disabled]="nextAction != nextEvaluationAction.ApproveWithTracing"
                                            (click)="viewSpecialTaskDetail(element)">
                                                <i class="material-icons">find_in_page</i>
                                            </button>
                                            <button mat-icon-button (click)="openPrevTaskDetail(element)" *ngIf="element.canBeReUsed">
                                                <mat-icon>visibility</mat-icon>
                                            </button>
                                        </mat-cell>
                                    </ng-container>

                                    <ng-container matColumnDef="noRecord">
                                            <mat-footer-cell *matFooterCellDef>
                                                <div style="width: 100%;text-align: center;">{{'SCORE_PAGE.TABLE_SPECIAL_ACTIONS.EMPTY' | translate}}</div>
                                            </mat-footer-cell>
                                    </ng-container>

                                    <mat-header-row *matHeaderRowDef="displayedColumnsSpecial"></mat-header-row>
                                    <mat-row class="mobile-table-row" *matRowDef="let row; columns: displayedColumnsSpecial;"></mat-row>

                                    <mat-footer-row
                                        *matFooterRowDef="['noRecord']"
                                        [hidden]="specialActionsDataSource.data.length > 0">
                                    </mat-footer-row>
                                </mat-table>
                                </div>

                            </div>
                        </kt-portlet-body>
                    </kt-portlet>
                </div>

                <div *ngIf="optionalActionsDataSource.data.length > 0 && (nextAction === nextEvaluationAction.ApproveWithTracing)"
                    style="position: relative; top: 3em; margin-bottom: 2.5em;">
                    <div class="action-label">{{'SCORE_PAGE.TABLE_OPTIONAL_ACTIONS.TITLE' | translate}}</div>

                    <kt-portlet class="kt-portlet--bordered" style="margin-top: 3em">
                        <kt-portlet-body>
                            <div class="lmat-elevation-z8">
                                <div class="mobile-table-container">
                                    <!-- Tabla acciones por respuesta -->
                                <mat-table [dataSource]="optionalActionsDataSource" class="mobile-table">
                                    <ng-container matColumnDef="reviewed" >
                                        <mat-header-cell *matHeaderCellDef class="recommended-col">
                                            <div>
                                                {{'SCORE_PAGE.TABLE_OPTIONAL_ACTIONS.HEADER.REVIEW' | translate}}
                                            </div>
                                        </mat-header-cell>
                                        <mat-cell *matCellDef="let element" class="recommended-col">
                                            <div>
                                                <mat-checkbox
                                                    [(ngModel)]="element.activeReviewed"
                                                    [disabled]="(editLocked$ | async) || nextAction != nextEvaluationAction.ApproveWithTracing">
                                                </mat-checkbox>
                                            </div>
                                        </mat-cell>
                                    </ng-container>

                                    <ng-container matColumnDef="recommended" >
                                        <mat-header-cell *matHeaderCellDef class="recommended-col">
                                            <div *ngIf="!review">{{'SCORE_PAGE.TABLE_OPTIONAL_ACTIONS.HEADER.DEFAULT' | translate}}</div>
                                            <div *ngIf="review">{{'SCORE_PAGE.TABLE_OPTIONAL_ACTIONS.HEADER.DEFAULT_REVIEW' | translate}}</div>
                                        </mat-header-cell>
                                        <mat-cell *matCellDef="let element" class="recommended-col">
                                            <div>
                                                <mat-checkbox
                                                    [(ngModel)]="element.active"
                                                    [disabled]="((editLocked$ | async) || nextAction != nextEvaluationAction.ApproveWithTracing) || review">
                                                </mat-checkbox>
                                            </div>
                                        </mat-cell>
                                    </ng-container>

                                    <ng-container matColumnDef="tracingaction">
                                        <mat-header-cell *matHeaderCellDef>{{'SCORE_PAGE.TABLE_OPTIONAL_ACTIONS.HEADER.TASK' | translate}}</mat-header-cell>
                                        <mat-cell *matCellDef="let element">{{element.description}}</mat-cell>
                                    </ng-container>

                                    <ng-container matColumnDef="responsableRole">
                                            <mat-header-cell *matHeaderCellDef>{{'SCORE_PAGE.TABLE_OPTIONAL_ACTIONS.HEADER.RESPONSABLE_ROLE' | translate}}</mat-header-cell>
                                            <mat-cell *matCellDef="let element">{{ element.roleDescription }}</mat-cell>
                                    </ng-container>

                                    <ng-container matColumnDef="use_last_plan" >
                                        <mat-header-cell *matHeaderCellDef class="recommended-col">
                                            {{'SCORE_PAGE.TABLE_DEFAULT_ACTIONS.HEADER.USE_LAST_PLAN' | translate}}
                                        </mat-header-cell>
                                        <mat-cell *matCellDef="let element" class="recommended-col">
                                            <div *ngIf="element.canBeReUsed">
                                                <mat-checkbox
                                                    [(ngModel)]="element.reUseTask"
                                                    [disabled]="(editLocked$ | async) || (review ? !element.activeReviewed : !element.active)">
                                                </mat-checkbox>
                                            </div>
                                        </mat-cell>
                                    </ng-container>

                                    <ng-container matColumnDef="reset_expiration" >
                                        <mat-header-cell *matHeaderCellDef class="recommended-col">
                                            {{'SCORE_PAGE.TABLE_DEFAULT_ACTIONS.HEADER.RESET_EXPIRATION' | translate}}
                                        </mat-header-cell>
                                        <mat-cell *matCellDef="let element" class="recommended-col">
                                            <div *ngIf="element.reUseTask">
                                                <mat-checkbox
                                                    [(ngModel)]="element.rebuiltExpirationDate"
                                                    [disabled]="(editLocked$ | async) || (review ? !element.activeReviewed : !element.active)">
                                                </mat-checkbox>
                                            </div>
                                        </mat-cell>
                                    </ng-container>

                                    <ng-container matColumnDef="view_detail">
                                        <mat-header-cell *matHeaderCellDef class="recommended-col">{{'SCORE_PAGE.TABLE_EXTRA_ACTIONS.HEADER.ACTIONS' | translate}}</mat-header-cell>
                                        <mat-cell *matCellDef="let element" class="recommended-col">
                                            <button mat-icon-button (click)="openPrevTaskDetail(element)"
                                                    *ngIf="element.canBeReUsed">
                                                <mat-icon>visibility</mat-icon>
                                            </button>
                                        </mat-cell>
                                    </ng-container>

                                    <ng-container matColumnDef="noRecord">
                                            <mat-footer-cell *matFooterCellDef>
                                                <div style="width: 100%;text-align: center;">{{'SCORE_PAGE.TABLE_SPECIAL_ACTIONS.EMPTY' | translate}}</div>
                                            </mat-footer-cell>
                                    </ng-container>

                                    <mat-header-row *matHeaderRowDef="optionalColumns"></mat-header-row>
                                    <mat-row class="mobile-table-row" *matRowDef="let row; columns: optionalColumns;"></mat-row>

                                    <mat-footer-row
                                        *matFooterRowDef="['noRecord']"
                                        [hidden]="optionalActionsDataSource.data.length > 0">
                                    </mat-footer-row>
                                </mat-table>
                                </div>

                            </div>
                        </kt-portlet-body>
                    </kt-portlet>
                </div>

                <div style="position: relative; top: 3em;" *ngIf="nextAction === nextEvaluationAction.ApproveWithTracing">
                    <div class="action-label">{{'SCORE_PAGE.TABLE_EXTRA_ACTIONS.PREV_TITLE' | translate}}</div>

                    <kt-portlet class="kt-portlet--bordered">
                        <kt-portlet-body>
                            <div class="lmat-elevation-z8">
                                <div class="mobile-table-container">
                                <mat-table #prevCustomTracingActionTable [dataSource]="prevCustomActionsDataSource" class="mobile-table">

                                    <!-- <ng-container matColumnDef="reviewed" >
                                        <mat-header-cell *matHeaderCellDef class="recommended-col">
                                            <div>
                                                {{'SCORE_PAGE.TABLE_OPTIONAL_ACTIONS.HEADER.REVIEW' | translate}}
                                            </div>
                                        </mat-header-cell>
                                        <mat-cell *matCellDef="let element" class="recommended-col">
                                            <div>
                                                <mat-checkbox
                                                    [(ngModel)]="element.activeReviewed"
                                                    [disabled]="(editLocked$ | async) || nextAction != nextEvaluationAction.ApproveWithTracing">
                                                </mat-checkbox>
                                            </div>
                                        </mat-cell>
                                    </ng-container> -->

                                    <ng-container matColumnDef="recommended" >
                                        <mat-header-cell *matHeaderCellDef class="recommended-col">
                                            <div *ngIf="!review">{{'SCORE_PAGE.TABLE_OPTIONAL_ACTIONS.HEADER.DEFAULT' | translate}}</div>
                                            <div *ngIf="review">{{'SCORE_PAGE.TABLE_OPTIONAL_ACTIONS.HEADER.DEFAULT_REVIEW' | translate}}</div>
                                        </mat-header-cell>
                                        <mat-cell *matCellDef="let element" class="recommended-col">
                                            <div>
                                                <mat-checkbox
                                                    [(ngModel)]="element.active"
                                                    [disabled]="((editLocked$ | async) || nextAction != nextEvaluationAction.ApproveWithTracing)">
                                                </mat-checkbox>
                                            </div>
                                        </mat-cell>
                                    </ng-container>

                                    <ng-container matColumnDef="tracingaction">
                                            <mat-header-cell *matHeaderCellDef class="custom-tracing-col">{{'SCORE_PAGE.TABLE_EXTRA_ACTIONS.HEADER.TRACING_ACTION' | translate}}</mat-header-cell>
                                            <mat-cell *matCellDef="let element" class="custom-tracing-col">{{element.description}}</mat-cell>
                                    </ng-container>

                                    <ng-container matColumnDef="expirationDate">
                                            <mat-header-cell *matHeaderCellDef>{{'SCORE_PAGE.TABLE_EXTRA_ACTIONS.HEADER.EXPIRATION' | translate}}</mat-header-cell>
                                            <mat-cell *matCellDef="let element">{{ element.expirationType.description }}</mat-cell>
                                    </ng-container>

                                    <ng-container matColumnDef="responsableRole">
                                            <mat-header-cell *matHeaderCellDef>{{'SCORE_PAGE.TABLE_EXTRA_ACTIONS.HEADER.RESPONSABLE_ROLE' | translate}}</mat-header-cell>
                                            <mat-cell *matCellDef="let element">{{ element.roleDescription }}</mat-cell>
                                    </ng-container>

                                    <ng-container matColumnDef="use_last_plan" >
                                        <mat-header-cell *matHeaderCellDef class="recommended-col">
                                            {{'SCORE_PAGE.TABLE_DEFAULT_ACTIONS.HEADER.USE_LAST_PLAN' | translate}}
                                        </mat-header-cell>
                                        <mat-cell *matCellDef="let element" class="recommended-col">
                                            <div *ngIf="element.canBeReUsed">
                                                <mat-checkbox
                                                    [(ngModel)]="element.reUseTask"
                                                    [disabled]="(editLocked$ | async) || !element.active">
                                                </mat-checkbox>
                                            </div>
                                        </mat-cell>
                                    </ng-container>

                                    <ng-container matColumnDef="reset_expiration" >
                                        <mat-header-cell *matHeaderCellDef class="recommended-col">
                                            {{'SCORE_PAGE.TABLE_DEFAULT_ACTIONS.HEADER.RESET_EXPIRATION' | translate}}
                                        </mat-header-cell>
                                        <mat-cell *matCellDef="let element" class="recommended-col">
                                            <div *ngIf="element.reUseTask">
                                                <mat-checkbox
                                                    [(ngModel)]="element.rebuiltExpirationDate"
                                                    [disabled]="(editLocked$ | async) || !element.active">
                                                </mat-checkbox>
                                            </div>
                                        </mat-cell>
                                    </ng-container>

                                    <ng-container matColumnDef="view_detail">
                                        <mat-header-cell *matHeaderCellDef >
                                            {{'SCORE_PAGE.TABLE_COMMON.HEADER.VIEW_DETAIL' | translate}}
                                        </mat-header-cell>
                                        <mat-cell *matCellDef="let element">
                                            <button mat-icon-button (click)="openPrevTaskDetail(element)">
                                                <mat-icon>visibility</mat-icon>
                                            </button>
                                        </mat-cell>
                                    </ng-container>

                                    <!-- <ng-container matColumnDef="actions">
                                        <mat-header-cell *matHeaderCellDef>{{'SCORE_PAGE.TABLE_EXTRA_ACTIONS.HEADER.ACTIONS' | translate}}</mat-header-cell>
                                        <mat-cell *matCellDef="let element">
                                            <button
                                            [matTooltip]="'SCORE_PAGE.TABLE_EXTRA_ACTIONS.TOOLTIP.EDIT_ACTION' | translate"
                                            mat-icon-button color="primary"
                                            class="medium"
                                            [disabled]="(editLocked$ | async) || nextAction != nextEvaluationAction.ApproveWithTracing"
                                            (click)="editCustomTracingAction(element.id)"
                                            >
                                                <i class="material-icons">edit</i>
                                            </button>
                                            <button
                                            [matTooltip]="'SCORE_PAGE.TABLE_EXTRA_ACTIONS.TOOLTIP.DELETE_ACTION' | translate"
                                            mat-icon-button color="primary"
                                            class="medium"
                                            [disabled]="(editLocked$ | async) || nextAction != nextEvaluationAction.ApproveWithTracing"
                                            (click)="deleteCustomTracingAction(element.id)"
                                            >
                                                <i class="material-icons">delete</i>
                                            </button>
                                        </mat-cell>
                                    </ng-container> -->

                                    <ng-container matColumnDef="noRecord">
                                        <mat-footer-cell *matFooterCellDef>
                                            <div style="width: 100%;text-align: center;">{{'SCORE_PAGE.TABLE_EXTRA_ACTIONS.EMPTY' | translate}}</div>
                                        </mat-footer-cell>
                                    </ng-container>


                                    <mat-header-row *matHeaderRowDef="displayedPrevColumnsCustom"></mat-header-row>
                                    <mat-row class="mobile-table-row" *matRowDef="let row; columns: displayedPrevColumnsCustom;"></mat-row>

                                    <mat-footer-row
                                        *matFooterRowDef="['noRecord']"
                                        [hidden]="prevCustomActionsDataSource.data.length > 0">
                                    </mat-footer-row>

                                </mat-table>
                                </div>

                            </div>
                        </kt-portlet-body>
                    </kt-portlet>
                </div>

                <div style="position: relative; top: 3em;" *ngIf="nextAction === nextEvaluationAction.ApproveWithTracing">
                    <div class="action-label">{{'SCORE_PAGE.TABLE_EXTRA_ACTIONS.TITLE' | translate}}</div>

                    <kt-portlet class="kt-portlet--bordered">
                        <kt-portlet-body>
                            <div id="addTask">
                                <button mat-raised-button color="primary"
                                    [disabled]="(editLocked$ | async) || nextAction != nextEvaluationAction.ApproveWithTracing"
                                    (click)="openAddTracingActionDialog(customTracingActionTable)">
                                    <i class="material-icons md-48">add</i>
                                    {{'SCORE_PAGE.TABLE_EXTRA_ACTIONS.ADD_ACTION_BUTTON' | translate}}
                                </button>
                            </div>

                            <div class="lmat-elevation-z8">
                                <div class="mobile-table-container">
                                <mat-table #customTracingActionTable [dataSource]="customActionsDataSource" class="mobile-table">

                                    <ng-container matColumnDef="tracingaction">
                                            <mat-header-cell *matHeaderCellDef class="custom-tracing-col">{{'SCORE_PAGE.TABLE_EXTRA_ACTIONS.HEADER.TRACING_ACTION' | translate}}</mat-header-cell>
                                            <mat-cell *matCellDef="let element" class="custom-tracing-col">{{element.description}}</mat-cell>
                                    </ng-container>

                                    <ng-container matColumnDef="expirationDate">
                                            <mat-header-cell *matHeaderCellDef>{{'SCORE_PAGE.TABLE_EXTRA_ACTIONS.HEADER.EXPIRATION' | translate}}</mat-header-cell>
                                            <mat-cell *matCellDef="let element">{{ element.expirationType.description }}</mat-cell>
                                    </ng-container>

                                    <ng-container matColumnDef="responsableRole">
                                            <mat-header-cell *matHeaderCellDef>{{'SCORE_PAGE.TABLE_EXTRA_ACTIONS.HEADER.RESPONSABLE_ROLE' | translate}}</mat-header-cell>
                                            <mat-cell *matCellDef="let element">{{ element.roleDescription }}</mat-cell>
                                    </ng-container>

                                    <ng-container matColumnDef="actions">
                                        <mat-header-cell *matHeaderCellDef>{{'SCORE_PAGE.TABLE_EXTRA_ACTIONS.HEADER.ACTIONS' | translate}}</mat-header-cell>
                                        <mat-cell *matCellDef="let element">
                                            <button
                                            [matTooltip]="'SCORE_PAGE.TABLE_EXTRA_ACTIONS.TOOLTIP.EDIT_ACTION' | translate"
                                            mat-icon-button color="primary"
                                            class="medium"
                                            [disabled]="(editLocked$ | async) || nextAction != nextEvaluationAction.ApproveWithTracing"
                                            (click)="editCustomTracingAction(element.id)"
                                            >
                                                <i class="material-icons">edit</i>
                                            </button>
                                            <button
                                            [matTooltip]="'SCORE_PAGE.TABLE_EXTRA_ACTIONS.TOOLTIP.DELETE_ACTION' | translate"
                                            mat-icon-button color="primary"
                                            class="medium"
                                            [disabled]="(editLocked$ | async) || nextAction != nextEvaluationAction.ApproveWithTracing"
                                            (click)="deleteCustomTracingAction(element.id)"
                                            >
                                                <i class="material-icons">delete</i>
                                            </button>
                                        </mat-cell>
                                    </ng-container>

                                    <ng-container matColumnDef="noRecord">
                                        <mat-footer-cell *matFooterCellDef>
                                            <div style="width: 100%;text-align: center;">{{'SCORE_PAGE.TABLE_EXTRA_ACTIONS.EMPTY' | translate}}</div>
                                        </mat-footer-cell>
                                    </ng-container>


                                    <mat-header-row *matHeaderRowDef="displayedColumnsCustom"></mat-header-row>
                                    <mat-row class="mobile-table-row" *matRowDef="let row; columns: displayedColumnsCustom;"></mat-row>

                                    <mat-footer-row
                                        *matFooterRowDef="['noRecord']"
                                        [hidden]="customActionsDataSource.data.length > 0">
                                    </mat-footer-row>

                                </mat-table>
                                </div>

                            </div>
                        </kt-portlet-body>
                    </kt-portlet>
                </div>

                <!-- Justificación de los cambios realizados -->
                <div
                    *ngIf="!(editLocked$ | async) || review"
                    class="form-group row"
                    style="position: relative; top: 3em;"
                    [formGroup]="scoreResultFormGroup">
                    <label class="col-lg-4 col-form-label">
                        <div *ngIf="!review">{{'SCORE_PAGE.RESULT.ACTIONS_OBSERVATION' | translate}}</div>
                        <div *ngIf="review">{{'SCORE_PAGE.RESULT.ACTIONS_OBSERVATION_REVIEW' | translate}}</div>
                    </label>
                    <div class="col-lg-8">
                        <mat-form-field class="mat-form-field-fluid">
                            <input
                                matInput
                                formControlName="changesObservation"
                                #textInput>
                            <mat-hint align="end">{{textInput.value.length}} / {{maxInputLength}}</mat-hint>
                            <!-- errors -->
                            <mat-hint *ngIf="scoreResultFormGroup.get('changesObservation').errors?.required">{{'AUTH.VALIDATION.REQUIRED_FIELD' | translate}} &nbsp;</mat-hint>
                            <mat-hint *ngIf="scoreResultFormGroup.get('changesObservation').errors?.maxlength">{{'AUTH.VALIDATION.MAX_LENGTH_FIELD' | translate | stringFormat: maxInputLength}} &nbsp;</mat-hint>
                            <mat-hint *ngIf="scoreResultFormGroup.get('changesObservation').errors?.minlength">{{'AUTH.VALIDATION.MIN_LENGTH_FIELD' | translate | stringFormat: minInputLength}} &nbsp;</mat-hint>
                            <mat-hint *ngIf="scoreResultFormGroup.get('changesObservation').errors?.blankSpaces">{{'AUTH.VALIDATION.BLANK_FIELD' | translate }} &nbsp;</mat-hint>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <!-- MAIN PAGE -->

            <div class="button-form-row">
                <button
                    mat-raised-button color="primary"
                    (click)="confirmEvaluationResult()"
                    [disabled]="(pageLoading$ | async) || scoreResultFormGroup.invalid">
                    <div
                        [matTooltipDisabled]="!scoreResultFormGroup.invalid"
                        [matTooltip]="'SCORE_PAGE.RESULT.TOOLTIP.CONTINUE_BUTTON' | translate">
                        <div *ngIf="!review">{{'SCORE_PAGE.BUTTONS.CONTINUE' | translate}}</div>
                        <div *ngIf="review">{{'SCORE_PAGE.BUTTONS.CONTINUE_REVIEW' | translate}}</div>
                    </div>
                </button>
                <button
                    mat-raised-button color="primary" class="btn-return"
                    (click)="cancelEvaluationResult()">
                    <div *ngIf="!review">{{'SCORE_PAGE.BUTTONS.CANCEL' | translate}}</div>
                    <div *ngIf="review">
                        <i class="flaticon2-fast-back"></i>
                        {{'SCORE_PAGE.BUTTONS.CANCEL_REVIEW' | translate}}
                    </div>
                </button>
            </div>
        </kt-portlet-body>
        <!-- end::Body -->
</kt-portlet>




